// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import urls from  '@src/@core/auth/jwt/urls'
// ** Axios Imports
import axios from 'axios'
import { errorToast, sucessToast } from '../../../components/messageToast/messageToast'

const qs = require('qs')

export const getAllCampaigns = createAsyncThunk('appCampaigns/getAllCampaigns', async (params) => {
  const instanceCampaign = axios.create({
    baseURL: urls.url,
    timeout: 15000,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })
  const response = await instanceCampaign.get(`/campaigns/campaigns_list/`, {params: {p:params.page, search:params.query}})
  return response
})

export const getAllCustomersByCampaign = createAsyncThunk('appCampaigns/getAllCustomersByCampaign', async (params) => {
  const instanceAllCustomersByCampaign = axios.create({
    baseURL: urls.url,
    timeout: 15000,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })
  const response = await instanceAllCustomersByCampaign.get(`/customers/customerCampaign/${params.idCampaign}`, {params: {p:params.page, search:params.query}})
  console.log(response.data.results)
  return response
})

export const getAllTemplates = createAsyncThunk('appCampaigns/getAllTemplates', async () => {
  const instanceTemplate = axios.create({
    baseURL: urls.url,
    timeout: 15000,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })
  const response = await instanceTemplate.get(`/customers/templates_all/`)
  return response
})

export const cleanCampaign = createAsyncThunk('appCampaigns/cleanCampaign', () => {
  return "clean"
})

export const getAllGroups = createAsyncThunk('appCampaigns/getAllGroups', async () => {
  const instanceAllGroups = axios.create({
    baseURL: urls.url,
    timeout: 15000,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })
  const response = await instanceAllGroups.get(`/customers/groups_all/`)
  return response
})

export const getCampaign = createAsyncThunk('appCampaigns/getCampaign', async id => {
  const instanceCampaign = axios.create({
    baseURL: urls.url,
    timeout: 15000,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })
  const response = await instanceCampaign.get(`/campaigns/campaigns/${id}/`)
  return response.data
})

export const addCampaign = createAsyncThunk('appCampaigns/addCampaign', async (params, { dispatch }) => {
  const instanceAddCampaign = axios.create({
    baseURL: urls.url,
    timeout: 15000,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
  })
  instanceAddCampaign.post('/campaigns/campaigns/', params.campaign)
    .then(async resp => {
      console.log(resp)
      await dispatch(getAllCampaigns({page:1, query:""}))
      sucessToast("Campaña creada correctamente")
      return resp.data
    })
    .catch((err) => {
      if (err?.response?.data?.error) {
        errorToast(err.response.data.msg)
      } else {
        errorToast("Campaña no fue creado correctamente")
      }
    })
})

export const updateCampaign = createAsyncThunk('appCampaigns/updateCampaign', (params, { dispatch }) => {
  const instanceUpdateCampaign = axios.create({
    baseURL: urls.url,
    timeout: 15000,
    headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/x-www-form-urlencoded"}
  })
  instanceUpdateCampaign.put(`/campaigns/campaigns/${params.campaign.id}/`, qs.stringify(params.campaign))
  .then(async resp => {
    await dispatch(getCampaign(params.campaign.id))
    sucessToast("Campaña se modifico correctamente")
    return resp.data
  })
  .catch(() => {
    errorToast("Campaña no se modifico correctamente")
  })
})


export const deleteCampaign = createAsyncThunk('appCampaigns/deleteCampaign', async (id, { dispatch}) => {
  await axios.delete(`/campaigns/campaigns/${id}/`)
  await dispatch(getAllCampaigns({page:1, query:""}))
  return id
})

export const appCampaignsSlice = createSlice({
  name: 'appCampaigns',
  initialState: {
    allCampaigns: [],
    allGroups: [],
    allTemplates: [],
    allCustomersByCampaign: [],
    totalCustomersByCampaign: 1,
    total: 1,
    selectedCampaign: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllCampaigns.fulfilled, (state, action) => {
        state.allCampaigns = action.payload.data.results
        state.total = action.payload.data.count
      })
      .addCase(getAllCustomersByCampaign.fulfilled, (state, action) => {
        state.allCustomersByCampaign = action.payload.data.results
        state.totalCustomersByCampaign = action.payload.data.count
      })
      .addCase(getAllTemplates.fulfilled, (state, action) => {
        state.allTemplates = action.payload.data
        console.log("Template", state.allTemplates)
      })
      .addCase(getAllGroups.fulfilled, (state, action) => {
        state.allGroups = action.payload.data
        console.log("Grupo", state.allGroups)
      })

      .addCase(cleanCampaign.fulfilled, (state) => {
        state.allCampaigns = []
        state.total = 1
      })

      .addCase(getCampaign.fulfilled, (state, action) => {
        state.selectedCampaign = action.payload
      })

  }
})

export default appCampaignsSlice.reducer
